import React from 'react';
import t from '~t';
import { LongDate } from '~modules/format/date';
import { Label } from '~ui';

export default function ProPeriod({ subscription: { stopAt, renewAt } }) {
  if (stopAt)
    return (
      <>
        <Label>{t.s('willStop')}</Label>
        <div className='self-center'>
          <LongDate date={stopAt} />
        </div>
      </>
    );

  return (
    <>
      <Label>{t.s('nextPayment')}</Label>
      <div className='self-center'>
        {renewAt && <LongDate date={renewAt} />}
      </div>
    </>
  );
}
